import React from 'react';
import { formatDate } from '@koob/dates';
import FieldLabel from './FieldLabel';
import ValueRenderer from './ValueRenderer';

// Fields to display in the period summary (in order)
const PERIOD_DISPLAY_FIELDS = [
  'state',
  'price',
  'allotments',
  'minPax',
  'maxPax',
  'autoConfirmEnabled',
  'autoConfirmDays',
];

// Boolean fields that should be shown even when null
const BOOLEAN_FIELDS = ['autoConfirmEnabled'];

export default function PeriodDisplay({ period, isNew = false }) {
  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';
  const dateRange = `${formatDate(period.startAt, 'D MMM YYYY')} - ${formatDate(period.endAt, 'D MMM YYYY')}`;

  // Get displayable fields that exist in the period
  // For boolean fields, show even if null (to display empty circle)
  const displayFields = PERIOD_DISPLAY_FIELDS.filter((field) => {
    if (BOOLEAN_FIELDS.includes(field)) {
      return field in period; // Show if field exists (even if null)
    }
    return period[field] !== undefined && period[field] !== null;
  });

  return (
    <div
      className={`flex flex-col gap-1 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <div className="flex items-center gap-2">
        <i className="fa-regular fa-calendar-range text-indigo-500" />
        <span className="text-sm font-medium text-gray-700">{dateRange}</span>
      </div>
      {displayFields.length > 0 && (
        <div className="ml-6 space-y-0.5">
          {displayFields.map((field) => (
            <div key={field}>
              <FieldLabel name={field} />
              <ValueRenderer value={period[field]} fieldName={field} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
